import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { useTheme } from '../../../../../../../theming/useTheme';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../../../../../partials/link/TextLink';
import { MEDIA_BREAKPOINTS } from '../../../../../../../mediaQueries.const';
import { P } from '../../../../../../../typography/semanticTags';
import { BaseUnit } from '../../../../../../../theming/baseUnitDefinition';

const componentConfigThemeKey = 'menuSubLink';

export interface MenuSubLinkDataProps {
  href: string,
  text: string,
}

interface MenuSubLinkThemeProps {
  baseUnit: BaseUnit
  idleColor: string,
}

const getMenuSubLinkStyle = (baseUnit: BaseUnit) => StyleSheet.create({
  style: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit}px ${baseUnit}px 0 ${baseUnit * 1.5}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit}px ${baseUnit}px 0 ${baseUnit * 1.5}px`,
    },
  },
});

export const MenuSubLinkComponent: React.FunctionComponent<MenuSubLinkThemeProps & MenuSubLinkDataProps> = props => {
  const { href, text, idleColor, baseUnit } = props;
  const linkStyle = generateLinkStyleFromTheme({ idleColor });
  const style = getMenuSubLinkStyle(baseUnit);
  return (
    <li className={css(style.style)}>
      <TextLinkComponent href={href} linkStyle={linkStyle}>
        <P>{text}</P>
      </TextLinkComponent>
    </li>
  );
};

const mapThemeProps = (theme: MenuSubLinkThemeProps) => {
  return {
    baseUnit: theme.baseUnit,
    idleColor: theme.idleColor,
  };
};

export const MenuSubLink = (props: MenuSubLinkDataProps) => {
  const themeContext = useTheme(mapThemeProps, componentConfigThemeKey);
  return <MenuSubLinkComponent {...themeContext} {...props} />;
};
